var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapMarkerHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 23.7794C48 39.5912 24.1262 63 24.0015 63C23.8768 63 -0.308625 39.1588 0.00298656 23.7794C0.269029 10.6491 10.7475 0 24.0015 0C37.2555 0 48 10.6464 48 23.7794Z",
    fill: "#F4849F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.392 17.7984C31.938 17.3484 31.3989 16.9914 30.8056 16.7478C30.2123 16.5043 29.5764 16.3789 28.9342 16.3789C28.292 16.3789 27.6561 16.5043 27.0628 16.7478C26.4695 16.9914 25.9304 17.3484 25.4764 17.7984L24.5342 18.7319L23.592 17.7984C22.6749 16.8898 21.4311 16.3794 20.1342 16.3794C18.8373 16.3794 17.5935 16.8898 16.6764 17.7984C15.7593 18.7069 15.2441 19.9392 15.2441 21.2241C15.2441 22.509 15.7593 23.7413 16.6764 24.6499L17.6186 25.5834L24.5342 32.4349L31.4497 25.5834L32.392 24.6499C32.8462 24.2001 33.2065 23.666 33.4523 23.0782C33.6982 22.4904 33.8247 21.8604 33.8247 21.2241C33.8247 20.5879 33.6982 19.9578 33.4523 19.37C33.2065 18.7822 32.8462 18.2482 32.392 17.7984V17.7984Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarkerHeart);
export default __webpack_public_path__ + "static/media/icon-map-marker-heart.a700bc117204c568614946d2adf1adf7.svg";
export { ForwardRef as ReactComponent };